import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  AssignmentListPage,
  NotificationPage,
  EmailRedirect,
  PublicRoute,
  PrivateRoute,
  MainLayout,
  LoginLayout,
  MobileApp,
  Information,
} from 'components';

const AuthenticationPage = lazy(() => import('./pages/AuthenticationPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const SettingPage = lazy(() => import('./pages/SettingPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const TranslationListPage = lazy(() => import('./pages/TranslationListPage'));

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route
            path="/"
            element={
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            }
          />
          <Route
            path="/my-assignments"
            element={
              <MainLayout>
                <AssignmentListPage />
              </MainLayout>
            }
          />
          <Route
            path="/notifications"
            element={
              <MainLayout>
                <NotificationPage />
              </MainLayout>
            }
          />
          <Route
            path="/translations"
            element={
              <MainLayout>
                <TranslationListPage />
              </MainLayout>
            }
          />
          <Route
            path="/contact-and-faq"
            element={
              <MainLayout>
                <ContactPage />
              </MainLayout>
            }
          />
          <Route
            path="/settings"
            element={
              <MainLayout>
                <SettingPage />
              </MainLayout>
            }
          />
          <Route
            path="/releases-page"
            element={
              <MainLayout>
                <NewsPage />
              </MainLayout>
            }
          />
          <Route
            path="/information"
            element={
              <MainLayout>
                <Information />
              </MainLayout>
            }
          />
        </Route>

        <Route element={<PublicRoute />}>
          <Route
            path="/login"
            element={
              <LoginLayout>
                <AuthenticationPage />
              </LoginLayout>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <LoginLayout>
                <ForgotPasswordPage />
              </LoginLayout>
            }
          />
          <Route
            path="/email-redirect"
            element={
              <LoginLayout>
                <EmailRedirect />
              </LoginLayout>
            }
          />
        </Route>

        <Route path="/mobile-app/login" element={<MobileApp />} />
      </Routes>
    </Suspense>
  );
}

export default App;
